<script setup lang="ts">
import { onDeactivated, onUnmounted, ref } from "vue";
import { mapState } from "../../context/context";
import Pop from "../pop/Pop.vue";
import Page from "../base/Page.vue";
import RateXg from "./RateXg.vue";
import Button from "../form/Button.vue";
import IconClose from "../icon/IconClose.vue";
import {
  INIT,
  completeRate,
  type StoredRate,
  type RateShowMode
} from "./common";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Pop, Page, RateXg, Button, IconClose },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    title?: string; // 标题
    mode?: RateShowMode;
    editable?: boolean;
    init?: StoredRate;
  }>(),
  {
    title: "订单评价",
    mode: "all"
  }
);

const emits = defineEmits<{
  (event: "open"): void;
  (event: "close"): void;
  (event: "cancel"): void;
  (event: "confirm", v: StoredRate): void;
}>();

const mappedState = mapState([
  "color.foregroundPattern",
  "color.secondaryPattern",
  "color.fontPattern"
]);

let value: StoredRate = completeRate(
  props.init ?? {
    ...INIT
  }
);
function input(v) {
  value = v;
}

const el = ref();

function open() {
  el.value?.open();
}
function close() {
  el.value?.close();
}

function confirm() {
  // console.log(value);
  emits("confirm", value);
  close();
}

function cancel() {
  emits("cancel");
  close();
}

function destroy() {}

onUnmounted(() => {
  destroy();
});
onDeactivated(() => {
  destroy();
});

defineExpose({ open, close });
</script>

<template>
  <Pop
    ref="el"
    directionFrom="bottom"
    :closeWhenClickOverlay="false"
    @open="() => emits('open')"
    @close="() => emits('close')"
  >
    <div
      class="pop-rate-xg"
      :style="{
        backgroundColor: `${mappedState['color.secondaryPattern'].value}`,
        color: mappedState['color.fontPattern'].value
      }"
    >
      <div class="top">
        <Button
          class="close"
          mode="empty"
          @throttledClick="cancel"
        >
          <div style="width: 12px"><IconClose></IconClose></div>
        </Button>
        <div>{{ title }}</div>
      </div>
      <Page
        class="content"
        :style="{
          backgroundColor: `${mappedState['color.foregroundPattern'].value}`
        }"
      >
        <RateXg
          :mode="props.mode"
          :editable="props.editable"
          :init="props.init"
          @rate="input"
        ></RateXg>
        <div
          v-if="props.editable"
          class="btn"
        >
          <Button
            width="100%"
            mode="gradient"
            :capsule="true"
            @throttledClick="confirm"
          >
            匿名提交
          </Button>
        </div>
      </Page>
    </div>
  </Pop>
</template>

<style scoped>
.pop-rate-xg {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
}
.pop-rate-xg > .top {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  line-height: 56px;
  padding: 0 var(--yz-padding-horizontal, 15px);
}
.pop-rate-xg > .top > .close {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 36px;
  height: 100%;
  display: flex !important;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.pop-rate-xg > .top > div:nth-child(2) {
  flex: 1 1 auto;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  word-break: break-all;
}
.pop-rate-xg > .content {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
  padding-top: var(--yz-padding-vertical-double, 20px);
  padding-bottom: var(--yz-padding-horizontal, 15px);
}
.pop-rate-xg > .content .btn {
  padding: var(--yz-padding-vertical-double, 20px)
    var(--yz-padding-horizontal, 15px) 0 var(--yz-padding-horizontal, 15px);
}
</style>
